import React, {Component} from "react";

class NoMatch extends Component
{
	render()
	{
		document.title = "DateNight: 404";

		return (
			<div>
				<h2>Uh Oh...</h2>
			</div>
		);
	}
}

export default NoMatch;



// WEBPACK FOOTER //
// ./src/components/NoMatch.js